import { Component, inject } from '@angular/core';
import { IonButton } from '@ionic/angular/ion-button';
import { IonContent } from '@ionic/angular/ion-content';
import { TranslocoPipe } from '@jsverse/transloco';
import { Browser } from '@capacitor/browser';
import { ModalService } from '@services/utility-services/modal.service';
import { IconDisplayComponent } from '@shared/components/icon-display/icon-display.component';
import { TaskNotificationModalDataModel } from '@shared/models/notification/task-notification-modal-data.model';

@Component({
  selector: 'app-additional-customer-info-modal',
  templateUrl: './additional-customer-info-modal.component.html',
  styleUrls: ['./additional-customer-info-modal.component.scss'],
  imports: [
    IonContent,
    TranslocoPipe,
    IonButton,
    IconDisplayComponent
  ]
})
export class AdditionalCustomerInfoModalComponent {
  protected readonly modalService = inject(ModalService);

  public notification: TaskNotificationModalDataModel | null = null;

  protected async openExternalWebsiteAsync(link: string | null | undefined): Promise<void> {
    if (!link) {
      return;
    }

    await Browser.open({ url: link });
    this.modalService.closeModal();
  }
}
